import { deriveStatus } from "@/lib/public-hearings/apply-filters";
import { relativeDeadline } from "@/lib/public-hearings/deadline";
import type { Hearing } from "@/lib/public-hearings/types";

import { MEETING_DATE_FMT, MEETING_TIME_FMT } from "./constants";

const DEADLINE_DATE_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  weekday: "short",
  month: "short",
  day: "numeric",
});

// Glanceable 3-stat dossier strip — mirrors the day-block's stat
// grammar (mono kicker / tabular value / sub line) but anchored to
// the single hearing's marquee facts: meeting day, meeting time,
// submission window. The submissions cell carries the same pulsing
// dot used by the row's status box, so urgency reads consistently.
export function DetailDossier({ hearing: h }: { hearing: Hearing }) {
  const meetingTimeIso = h.meeting.meetingTimeUtc;
  const meetingDate = meetingTimeIso
    ? MEETING_DATE_FMT.format(new Date(meetingTimeIso))
    : "pending";
  const meetingTime = meetingTimeIso
    ? MEETING_TIME_FMT.format(new Date(meetingTimeIso))
    : "—";

  const status = deriveStatus(h);
  const relative = relativeDeadline(h.submissionDeadlineUtc);
  const deadlineDate = h.submissionDeadlineUtc
    ? `${DEADLINE_DATE_FMT.format(new Date(h.submissionDeadlineUtc))} · 12:00`
    : "no deadline yet";

  return (
    <dl className="ph-detail-r" aria-label="Hearing at a glance">
      <div className="ph-detail-stat">
        <dt className="l">Meeting</dt>
        <dd className="v" style={{ margin: 0 }}>
          {meetingDate}
        </dd>
        <dd className="sub" style={{ margin: 0 }}>
          {h.meeting.meetingType}
        </dd>
      </div>
      <div className="ph-detail-stat">
        <dt className="l">Time</dt>
        <dd className="v" style={{ margin: 0 }}>
          {meetingTime}
        </dd>
        <dd className="sub" style={{ margin: 0 }}>
          Calgary local
        </dd>
      </div>
      <div className="ph-detail-stat" data-tone={status}>
        <dt className="l">Submissions</dt>
        <dd className="v" style={{ margin: 0 }}>
          <span className="ph-detail-dot" aria-hidden />
          {relative.label}
        </dd>
        <dd className="sub" style={{ margin: 0 }}>
          {deadlineDate}
        </dd>
      </div>
    </dl>
  );
}
